import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { ChancenkurveSubjectConfig } from './ChancenkurveSubjectConfig.js';

/**
 * Global configuration for Chancenkurve feature
 * Controls whether the feature is enabled and stores threshold settings
 */
@Entity()
export class ChancenkurveConfig extends MongoEntity {
  public static override _class = 'ChancenkurveConfig';
  public static override _collectionName = 'chancenkurve-config';

  /**
   * Global toggle for Chancenkurve feature
   */
  @Field(() => Boolean)
  public enabled: Maybe<boolean>;

  /**
   * German subject threshold configuration
   */
  @Field(() => ChancenkurveSubjectConfig)
  public germanConfig: Maybe<ChancenkurveSubjectConfig>;

  /**
   * Math subtraction subject threshold configuration
   */
  @Field(() => ChancenkurveSubjectConfig)
  public mathSubtractionConfig: Maybe<ChancenkurveSubjectConfig>;
}
